function initOrDestroyCarousel() {
  const $carousel = $('.card-carousel');
  const $carouselList = $('.hgt-list');
  if (window.innerWidth < 992) {
    if (!$carousel.hasClass('owl-loaded')) {
      $carousel.owlCarousel({
        items: 1,
        margin: 20,
        loop: true,
        dots: true,
        nav: false,
        autoplay: true
      });
      $carouselList.owlCarousel({
        items: 1,
        margin: 20,
        loop: true,
        dots: true,
        nav: false,
        autoplay: true
      });
    }
  } else {
    if ($carousel.hasClass('owl-loaded')) {
      $carousel.trigger('destroy.owl.carousel');
      $carousel.removeClass('owl-loaded owl-carousel');
      $carousel.find('.owl-stage-outer').children().unwrap();
      $carousel.find('.owl-stage').children().unwrap();
    }
  }
}

$(document).ready(initOrDestroyCarousel);
$(window).on('resize', initOrDestroyCarousel);

  jQuery(document).ready(function(){
  	jQuery("#main-carousel").owlCarousel({
  		items: 4,          // show all slides (original + duplicate)
  		loop: false,      // important: turn off Owl loop
  		margin: 20,
  		dots: false,
  		nav: false,
  		autoplay: false, 
      responsive: {
    0: {
      items: 2 // from 0px up, show 2 items
    },
    768: {
      items: 3// from 768px up, show 4 items
    },
           992: {
      items: 4// from 768px up, show 4 items
    }
  }
});
  	jQuery(".accom-carousel").owlCarousel({
  		items: 1,          
  		loop: false,      
  		margin: 0,
  		dots: true,
  		nav: true,
  		navText: ['<span class="icomoon icon-icon_arw_prev"></span>', '<span class="icomoon icon-icon_arw_prev"></span>'],
  		autoplay: false,  // disable Owl autoplay → we handle it in CSS
  	});
  });
    
    jQuery(function(){
        jQuery("a.bla-1").YouTubePopUp();
        jQuery("a.bla-2").YouTubePopUp( { autoplay: 0 } ); // Disable autoplay
    });
    
    $(document).on('click', '.sidebar a[href^="#"]', function(e) {
      // target element id
      var id = $(this).attr('href');
      $('.sidebar li a').removeClass('active');
      
      // target element
      var $id = $(id);
      if ($id.length === 0) {
          return;
      }
      // prevent standard hash navigation (avoid blinking in IE)
      e.preventDefault();
     $(this).addClass('active');
      // top position relative to the document
      var pos = $id.offset().top;
      // animated top scrolling
      $('body, html').animate({scrollTop: pos});
      //var flotingBar = ( pos - 100 );
      //$('#content-box').animate({ top: flotingBar+'px' }, 1500, 'swing');
  });
  if ($(window).width() > 992) {
    var $bounding_box = $('#bounding-box');
    $('#content-box').floatingScroll($bounding_box, 'bounded');
  }

  // Function to handle scroll events
  function handleScroll() {
    const scrollPosition = window.pageYOffset; // Get current scroll position
    // Get all navigation links
    const navLinks = document.querySelectorAll('.sidebar li a');
    // Get all sections
    const sections = document.querySelectorAll('div.section');
    // Reset all links
    navLinks.forEach(link => {
      link.classList.remove('active');
    });
    // Find the active section and highlight its corresponding link
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const sectionTop = section.offsetTop; // Get the section's top position
      const sectionHeight = section.offsetHeight; // Get the section's height
      // Check if the section is in view
      if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
        const sectionId = section.id;
        const link = document.querySelector('.sidebar li a[href="#'+sectionId+'"]');
        $('.sidebar li a[href="#'+sectionId+'"]').addClass('active');
        break;
      }
    }
  }
  // Attach the scroll event listener
  //$(".main-data .section:not(.highlights):not(.sim-trips)").addClass("clps");
  window.addEventListener('scroll', handleScroll);
    $(".main-data > div > div.h2style").click(function() {
    $(this).closest(".section").toggleClass("clps");
  });